import TimeRange from "@/types/time/timeRange"

export class DateAndTimeHelper {
  getReadableDateFromStartingTime (startedMilliseconds: number) {
    if (!startedMilliseconds) {
      return
    }
    const date = new Date(startedMilliseconds)
    return this.twoDigits(date.getDate()) + "." + this.twoDigits(date.getMonth() + 1) + "." + this.twoDigits(date.getFullYear())
  }

  getReadableTimeFromStartingTime (startedMilliseconds: number) {
    if (!startedMilliseconds) {
      return
    }
    const date = new Date(startedMilliseconds)
    return this.twoDigits(date.getHours()) + ':' + this.twoDigits(date.getMinutes())
  }

  getNewMillisecondsDate (oldStartedAt: number, newStartedAt: number) {
    const startedAtDateAndTime = new Date(oldStartedAt)
    const newDate = new Date(newStartedAt)
    newDate.setHours(startedAtDateAndTime.getHours())
    newDate.setMinutes(startedAtDateAndTime.getMinutes())
    newDate.setSeconds(startedAtDateAndTime.getSeconds())
    return newDate
  }

  getMillisecondsFromTimeValue (startedAt: number, time: string) {
    const startedAtDateAndTime = new Date(startedAt)
    if (time) {
      const hours = time.split(':')[0]
      const minutes = time.split(':')[1]
      if (hours) startedAtDateAndTime.setHours(parseInt(hours))
      if (minutes) startedAtDateAndTime.setMinutes(parseInt(minutes))
    }
    return startedAtDateAndTime
  }

  getTrackedTime (startingTime: number, endTime: number) {
    const startingDate: any = new Date(startingTime)
    const endDate: any = new Date(endTime)
    const diffTime = Math.abs(endDate - startingDate)
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

    const date = new Date(Number(endTime) - Number(startingTime))
    date.setTime(date.getTime() + date.getTimezoneOffset() * 60 * 1000)
    return diffDays - 1 + 'T ' + this.twoDigits(date.getHours()) + ':' + this.twoDigits(date.getMinutes()) + ':' + this.twoDigits(date.getSeconds())
  }

  getTrackedTimeWithoutSeconds (startingTime: number, endTime: number) {
    const date = new Date(endTime - startingTime)
    return this.twoDigits(date.getHours() - 1) + ':' + this.twoDigits(date.getMinutes())
  }

  twoDigits (value: any) {
    if (value.toString().length <= 1) {
      return '0' + value.toString()
    }
    return value.toString()
  }

  getMonthRangeInMilliseconds (month: number, isLastMonth?: boolean) {
    let year = new Date().getFullYear()
    if (isLastMonth && month === 11) year = year - 1
    return new TimeRange({
      start: new Date(year, month, 1).setHours(0, 0, 0, 0),
      end: new Date(year, month + 1, 0).setHours(23, 59, 59, 999)
    })
  }

  getRoundedDateTimeToLess (dateTime?: Date) {
    const time = 1000 * 60 * 15 // 15 is the rounding time value
    const date = dateTime ? new Date(dateTime) : new Date()
    const rounded = new Date(date.getTime() - (date.getTime() % time))
    return rounded.getTime()
  }

  getRoundedDateTimeToMore (dateTime?: Date) {
    const time = 1000 * 60 * 15 // 15 is the rounding time value
    const date = dateTime ? new Date(dateTime) : new Date()
    const rounded = new Date(date.getTime() + time - (date.getTime() % time))
    return rounded.getTime()
  }

  timeStringToNumber (time: string) {
    const hoursMinutes = time.split(/[ .:]/)
    const hours = parseInt(hoursMinutes[0], 10)
    const minutes = hoursMinutes[1] ? parseInt(hoursMinutes[1], 10) : 0
    return Number((hours + minutes / 60).toFixed(2))
  }
}
